//const api_end_point = "https://www.qforecast.s.cmshelp.dk/";
const api_end_point = "https://forecast.qestit.com/"; // live URL
//const api_end_point = "http://localhost:50646/";
const azure_end_point = "https://graph.microsoft.com/v1.0/users/";
export default {
    api_end_point: api_end_point,
    azure_user_api: azure_end_point,
    user_api: api_end_point + "api/user",
    forecast_api: api_end_point + "api/forecast/fetch",
    oe_country_list_api: api_end_point + "api/forecast/oecountrylist",
    update_relation: api_end_point + "api/forecast/forecastrelation",
    update_allocation: api_end_point + "api/forecast/monthlyallocation",
    allocation_result: api_end_point + "api/forecast/aggregate",
    report_result: api_end_point + "api/reports/aggregate",
    qtime_api: api_end_point + "api/qtime/fetch",
    qtime_post_api: api_end_point + "api/qtime/postall",
    qtime_del_api: api_end_point + "api/qtime/delete",
    qtime_del_list_api: api_end_point + "api/qtime/deletelist",
    qtime_pin_api: api_end_point + "api/qtime/pin",
    qtime_release_api: api_end_point + "api/qtime/release",
    qtime_validate_api: api_end_point + "api/qtime/validate",
    internalposition_time: api_end_point + "api/qtime/internalpositiontime",

    qtime_unreleasedmonth_api: api_end_point + "api/qtime/unreleasedmonth",
    qtime_copy_api: api_end_point + "api/qtime/copy",
    bench_report_api: api_end_point + "api/reports/benchoverview",
    customer_turnover_report_api: api_end_point + "api/reports/customerturnover",
    customer_engagement_report_api: api_end_point + "api/reports/customerengagement",
    costusltant_workload_api: api_end_point + "api/reports/consultantWorkload",
    costusltant_workload_aggregate_api: api_end_point + "api/reports/workloadaggregate ",
    qcentris_unit_turnover_api: api_end_point + "api/reports/unitturnover",
    qcentris_country_turnover_api: api_end_point + "api/reports/countryturnover",

    reports_export_bench_api: api_end_point + "api/reports/excelreportforbench",
    reports_export_unit_turnover_api: api_end_point + "api/reports/excelreportforunitturnover",
    reports_export_customer_turnover_api: api_end_point + "api/reports/excelreportforcusomerturnover",
    reports_export_country_turnover_api: api_end_point + "api/reports/excelreportforcountryturnover",
    reports_export_customer_engagement_api: api_end_point + "api/reports/excelreportforcustomerengangement",
    reports_export_consultant_workload_api: api_end_point + "api/reports/excelreportforconsultantworkload",

    qtime_reports_activity: api_end_point + "/api/qtime/report/activity",
    qtime_export_activity: api_end_point + "api/qtime/activityreport",
    qtime_personal_overview: api_end_point + "/api/qtime/report/personal",
    qtime_export_personal_overview: api_end_point + "api/qtime/personalreport",
    qtime_export_finance_report: api_end_point + "api/qtime/financereport",
    qtime_location_overview: api_end_point + "/api/qtime/report/locations",
    qtime_export_location_overview: api_end_point + "api/qtime/locationoverview",
    qtime_team_overview: api_end_point + "/api/qtime/report/team",
    qtime_export_team_overview: api_end_point + "/api/qtime/teamoverview",
    qtime_oe_location: api_end_point + "/api/qtime/report/oelocations",
    qtime_release_emp_month_data: api_end_point + "/api/qtime/report/releaseemployeemonthdata",
    qtime_unrelease_emp_month_data: api_end_point + "/api/qtime/unreleaseselectedemployeemonth",
    qtime_release_overview: api_end_point + "api/qtime/releaseoverview",
    qtime_release_overview_manager: api_end_point + "api/qtime/releaseoverviewmanager",
    qtime_release_overview_ismanager_check: api_end_point + "api/qtime/releaseoverviewmanagercheck",
    qtime_release_overview_submitdata: api_end_point + "api/qtime/releasesubmitteddata",
    qtime_release_overview_submitdata_manager: api_end_point + "api/qtime/releasesubmitteddatamanager",
    qtime_time_recording_overview: api_end_point + "api/qtime/timerecordingoverview",
    qtime_time_employee_time_overview: api_end_point + "api/qtime/employeetimeoverview",
    qtime_time_vacation_report_overview: api_end_point + "api/qtime/vacationreportoverview",
    qtime_delivery_manager_employee_overview: api_end_point + "api/qtime/dmemployeeoverview",
    qtime_delivery_manager_external_project_overview: api_end_point + "api/qtime/dmexternalprojectoverview",
    qtime_delivery_manager_internal_project_overview: api_end_point + "api/qtime/dminternalprojectoverview",
    qtime_direct_manager_internal_project_overview: api_end_point + "api/qtime/directmanagerdashboardoverview",
    leaveRequest_vacation_requests_webform_link: "https://podio.com/webforms/26619862/2021493",
    sicknessRequest_sickness_requests_webform_link: "https://podio.com/webforms/26620524/2021568",
    //leaveRequest_vacation_requests_webform_link: "https://podio.com/webforms/26666256/2027149",      // stage-form
    //sicknessRequest_sickness_requests_webform_link: "https://podio.com/webforms/26666254/2027148", // stage-form

    qtime_export_employees_data: api_end_point + "api/qtime/employeesreoprt",
    fetchpdffilePath_api: api_end_point + "api/forecast/pdfPath",
}